/* sz-faq-v4.js — Single-open accordion for .ap-faq-card elements
 * Loaded via {{ 'sz-faq-v4.js' | asset_url | script_tag: defer: true }}
 */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.ap-faq__grid').forEach(function (grid) {
      var cards = grid.querySelectorAll('.ap-faq-card');
      cards.forEach(function (card) {
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        card.setAttribute('aria-expanded', 'false');
        var toggle = function () {
          var willOpen = !card.classList.contains('open');
          cards.forEach(function (c) {
            c.classList.remove('open');
            c.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) {
            card.classList.add('open');
            card.setAttribute('aria-expanded', 'true');
          }
        };
        card.addEventListener('click', toggle);
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
